/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Physio_ConsultationInputs */

const en_service_type_physio_consultation = /** @type {(inputs: Service_Type_Physio_ConsultationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physiotherapy consultation`)
};

const pl_service_type_physio_consultation = /** @type {(inputs: Service_Type_Physio_ConsultationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultacja fizjoterapeutyczna`)
};

/**
* | output |
* | --- |
* | "Physiotherapy consultation" |
*
* @param {Service_Type_Physio_ConsultationInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_physio_consultation = /** @type {((inputs?: Service_Type_Physio_ConsultationInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Physio_ConsultationInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_physio_consultation(inputs)
	return en_service_type_physio_consultation(inputs)
});